import { OVERVIEW_PANEL_SET_CURRENT, OVERVIEW_PANEL_SET_VISIBILITY } from './types';
import { openIntercom } from '../../../helpers/intercom.helper';

export const mutations = {
    [OVERVIEW_PANEL_SET_CURRENT]: (state, payload) => {
        state.current = payload;
        state.visible = true;
    },
    [OVERVIEW_PANEL_SET_VISIBILITY]: (state, payload) => {
        if (!payload) {
            setTimeout(() => openIntercom(window.intercomSettings.horizontal_padding, 55), 100);
        }
        state.visible = payload;
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/overview-panel/mutations.js